import "./css/questionPaper.css";

import AddIcon from "@mui/icons-material/Add";
import DescriptionIcon from "@mui/icons-material/Description";
import ArticleIcon from "@mui/icons-material/Article";
import QuizIcon from "@mui/icons-material/Quiz";
import { useNavigate } from "react-router-dom";
function QuestionPaper() {
  const navigate = useNavigate();

  return (
    <div>
      <>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {/* <li class="breadcrumb-item"><a href="/dashboard/Home">Home</a></li> */}
            <li
              className="breadcrumb-item active"
              aria-current="page"
              style={{ fontSize: "20px" }}
            >
              <strong>Question Paper Utility Dashboard</strong>
            </li>
          </ol>
          <ol className="breadcrumb">
            {/* <li class="breadcrumb-item"><a href="/dashboard/Home">Home</a></li> */}
            <li className="breadcrumb-item active" aria-current="page">
              Create, manage, and organize your question papers efficiently
            </li>
          </ol>
        </nav>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 10,
          }}
        >
          <a
            href="/createPaper"
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={(e) => {
              e.preventDefault();
              navigate("/createPaper");
            }}
          >
            <div
              className="text-center mb-3 shadow-sm  alert alert-primary"
              style={{ padding: 20, borderRadius: 10 }}
            >
              <div className="text-40 mb-2">
                <AddIcon sx={{ fontSize: 50 }} />
              </div>

              <div className="mb-2">
                <h5>Create New</h5>
              </div>
              <div className=" mb-2 text-16">
                <p>Start Creating Questions</p>
              </div>
            </div>
          </a>
          <a
            href="/qstnPapers"
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={(e) => {
              e.preventDefault();
              navigate("/qstnPapers");
            }}
          >
            <div
              className="text-center mb-3 shadow-sm  alert alert-success"
              style={{ padding: 20, borderRadius: 10 }}
            >
              <div className="text-40 mb-2">
                {/* <i class="bi bi-file-earmark-text"></i> */}
                <DescriptionIcon sx={{ fontSize: 50 }} />
              </div>
              <div className="mb-2">
                <h5>My Papers</h5>
              </div>
              <div className=" mb-2 text-16">
                <p>View All Questions Papers</p>
              </div>
            </div>
          </a>
          <a
            href="/workSheets"
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={(e) => {
              e.preventDefault();
              navigate("/workSheets");
            }}
          >
            <div
              className="text-center mb-3 shadow-sm  alert alert-danger"
              style={{ padding: 20, borderRadius: 10 }}
            >
              <div className="text-40 mb-2">
                <ArticleIcon sx={{ fontSize: 50 }} />
                {/* <i class="bi bi-file-earmark-text-fill"></i> */}
              </div>
              <div className="mb-2">
                <h5>Work Sheet</h5>
              </div>
              <div className=" mb-2 text-16">
                <p>Practice Worksheets</p>
              </div>
            </div>
          </a>
          <a
            href="/questionBank"
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={(e) => {
              e.preventDefault();
              navigate("/questionBank");
            }}
          >
            <div
              className="  mb-3 shadow-sm  alert alert-warning"
              style={{ padding: 20, borderRadius: 10 }}
            >
              <div className="text-40 p-3 mb-2">
                {/* <i class="bi bi-question-circle"></i> */}
                <QuizIcon sx={{ fontSize: 50 }} />
              </div>
              <div className="mb-2">
                <h5>My Question Bank</h5>
              </div>
              <div className=" mb-2 text-16">
                <p>Question Bank</p>
              </div>
            </div>
          </a>
        </div>

        <div
          className="mb-3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 20,
          }}
        ></div>
      </>
    </div>
  );
}

export default QuestionPaper;
